import { useEffect, useState } from "react";
import { APITypes } from "utils/api.types";
import { InstagramBlock } from "./InstagramBlock";
interface InstagramPost {
  id: string;
  caption: string;
  media_url: string;
  media_type: string;
  timestamp: string;
  thumbnail_url?: string;
  permalink?: string;
}
export interface InstagramBlockWrapperProps {
  block: APITypes.Components.ContentBlocks.InstagramBlock;
}
export const InstagramBlockWrapper = ({
  block
}: InstagramBlockWrapperProps) => {
  const [posts, setPosts] = useState<InstagramPost[]>([]);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch("/api/instagram");
        if (!response.ok) {
          throw new Error("Failed to fetch Instagram posts");
        }
        const data = await response.json();
        const sortedPosts = (data.data || []).sort((postA: InstagramPost, postB: InstagramPost) => new Date(postB.timestamp).getTime() - new Date(postA.timestamp).getTime());
        setPosts(sortedPosts);
      } catch (err) {
        console.error("Error fetching Instagram posts:", err);
        setError(err instanceof Error ? err.message : "Failed to fetch Instagram posts");
      }
    };
    fetchPosts();
  }, []);
  if (error) {
    console.error("Instagram block error:", error);
    return null;
  }
  return <InstagramBlock block={block} posts={posts} data-sentry-element="InstagramBlock" data-sentry-component="InstagramBlockWrapper" data-sentry-source-file="InstagramBlockWrapper.tsx" />;
};
export default InstagramBlockWrapper;